<div class="results__filters-menu" [ngStyle]="{ position:'fixed' }" *ngIf="filters$ | async as filters">
  <button *ngIf="filters" mb-button variant="floating" color="secondary"
    [loading]="!filters?.list?.length || (loading$ | async)" [disabled]="!filters?.list?.length || (loading$ | async)"
    (click)="toggleShowFilters()">
      <mb-icon icon="filter-equalizer"></mb-icon>
      <span>Filtrar</span>
      <span id="total-filter"><ng-container *ngIf="filters.applied?.length"> ({{filters.applied?.length}})</ng-container></span>
  </button>
  <ng-container *ngIf="!map">
    <span class="divider"></span>
    <am-sorting-by-mobile [loading]="loading$ | async"
      [disabled]="(loading$ | async) || !(hotels$ | async)?.length"></am-sorting-by-mobile> 
  </ng-container>
  <ng-container *ngIf="!(context$ | async)?.isLanding">
    <span class="divider"></span>
    <am-view-map [isMap]="map" [isMobile]="true"></am-view-map>
  </ng-container>
</div>